export default "__VITE_ASSET__6e6cd6a8__"